/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// Polyfill pro ECMAScript.
import 'core-js/features/array';
import 'core-js/features/number';
import 'core-js/features/object';
import 'core-js/features/string';
